import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../images/logo.png';
import { toast } from 'react-toastify';
import { forgetPassword } from '../../Api/authApi.js.js';

const ForgetPasswordPage = () => {
    const [email, setEmail] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!/\S+@\S+\.\S+/.test(email)) {
            toast.warning("Veuillez entrer une adresse e-mail valide.");
            return;
        }
        try {
            const response = await forgetPassword({ email });
            if (response) {
                toast.success(response.message);
            } else {
                toast.warning('Réponse vide du serveur.');
            }
        } catch (error) {
            toast.warning(error.message);
        }
    };

    return (
        <div style={{
            minHeight: '100vh', background: '#0A1226',
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center',
            padding: '32px 24px',
            WebkitFontSmoothing: 'antialiased',
            position: 'relative',
        }}>
            {/* Bouton retour */}
            <div style={{ position: 'absolute', top: 20, left: 20 }}>
                <Link to="/connexion" style={{ textDecoration: 'none' }}>
                    <button style={{
                        width: 38, height: 38, borderRadius: 12,
                        background: 'rgba(255,255,255,0.06)',
                        border: '1px solid rgba(255,255,255,0.08)',
                        display: 'grid', placeItems: 'center',
                        cursor: 'pointer', color: '#F2F5FB', padding: 0,
                    }}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                </Link>
            </div>

            <div style={{ width: '100%', maxWidth: 360 }}>
                {/* Logo */}
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 32 }}>
                    <img src={logo} alt="Trading Series" style={{ height: 48, width: 'auto' }} />
                </div>

                <p style={{
                    fontSize: 14, color: '#97A4BE', textAlign: 'center',
                    lineHeight: 1.6, marginBottom: 28,
                }}>
                    Saisis ton adresse e-mail pour recevoir un lien de réinitialisation de mot de passe.
                </p>

                <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {/* Email */}
                    <div style={{ position: 'relative' }}>
                        <span style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', color: '#5C6B88', display: 'flex' }}>
                            <svg width="16" height="16" viewBox="0 0 20 16" fill="currentColor">
                                <path d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z"/>
                                <path d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z"/>
                            </svg>
                        </span>
                        <input
                            type="email" name="email" value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Adresse e-mail"
                            required
                            style={{
                                width: '100%', background: 'rgba(255,255,255,0.05)',
                                border: '1px solid rgba(255,255,255,0.08)',
                                borderRadius: 14, color: '#F2F5FB', fontSize: 15,
                                padding: '14px 16px 14px 42px', outline: 'none',
                                boxSizing: 'border-box',
                            }}
                        />
                    </div>

                    <button type="submit" style={{
                        marginTop: 4, height: 54, borderRadius: 16, width: '100%',
                        background: 'linear-gradient(180deg, #ffffff 0%, #e3e8f1 100%)',
                        color: '#0A1226', border: 'none', cursor: 'pointer',
                        fontWeight: 700, fontSize: 15,
                        display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 9,
                        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.9), 0 10px 24px -10px rgba(0,0,0,0.6)',
                    }}>
                        Envoyer le lien
                    </button>
                </form>

                <p style={{ textAlign: 'center', marginTop: 24, fontSize: 14, color: '#5C6B88' }}>
                    <Link to="/connexion" style={{ color: '#97A4BE', fontWeight: 600, textDecoration: 'none' }}>
                        Retour à la connexion
                    </Link>
                </p>
            </div>
        </div>
    );
};

export default ForgetPasswordPage;
